export const mergeArraysAtSpecificIdx = (arr1, arr2, i = 0, removeIdx = 0) => [
  ...arr1.slice(removeIdx, i),
  ...arr2,
  ...arr1.slice(i),
];

export const defaultAscendingSort = (a: string | number, b: string | number) =>
  Number(a) - Number(b);

export const moveObjectToPosition = <T = any>(
  array: Array<T>,
  target: T,
  newPosition = 0,
  objectKey: string = "id",
): Array<T> => {
  const targetValue = target[objectKey];

  if (array.length === 1 && array[0][objectKey] === targetValue) {
    return array;
  }

  return array.reduce((currentArr, element) => {
    if (element[objectKey] === targetValue) {
      return currentArr;
    }

    const currentArrIndex = currentArr.length;

    if (currentArrIndex === newPosition) {
      currentArr.push(target);
    }

    currentArr.push(element);

    return currentArr;
  }, []);
};
